<script>
  import { getContext } from "svelte";
  import { urbanColors } from "@urbaninstitute/dataviz-components/utils";
  import { fade } from "svelte/transition";

  const { data, yScale, xGet, x } = getContext("LayerCake");

  let { filter } = $props();

  let showPoint = $derived((point) => {
    if (!filter) return false;
    return $x(point) === filter;
  });
</script>

<g class="points-group">
  {#each $data as group (group.key)}
    {#each group as point (`${group.key}-${$x(point)}`)}
      {#if showPoint(point)}
          <!-- fill={$zGet(group)} -->
        <circle
          in:fade={{ duration: 100, delay: 100 }}
          r="4"
          cx={$xGet(point)}
          cy={$yScale(point[1])}
          fill={urbanColors.white}
          stroke={urbanColors.black}
          stroke-width="1"
        />
      {/if}
    {/each}
  {/each}
</g>
